import { debounce, FormControl, Stack, TextField, Typography } from "@mui/material";
import { useFormikContext } from "formik";
import React, { useRef, useEffect } from "react";
import { useIntl } from "react-intl";

import { initialValue } from "../../Form/helpers";
import { QuestionProps } from "../interfaces";

const TextQuestion: React.FC<QuestionProps> = ({ saveDraft, ...props }) => {
    const saveDraftRef = useRef(saveDraft);
    useEffect(() => {
        saveDraftRef.current = saveDraft;
    }, [saveDraft]);

    const debounceFunc = useRef(
        debounce((val: string) => {
            saveDraftRef.current([val]);
        }, 1000)
    ).current;

    const { formatMessage } = useIntl();
    const { values, errors, getFieldMeta, setFieldValue } = useFormikContext<Record<string, initialValue>>();
    const error = errors[props.question.id];
    const formValue = values[props.question.id];

    const { touched } = getFieldMeta(`${props.question.id}.value`);

    if (!formValue) {
        return null;
    }

    const maxCharacters = props.question.maxChars;
    let counterText: string | undefined;
    if (maxCharacters) {
        counterText = `${(formValue.value as string).length}/${maxCharacters}`;
    }

    return (
        <FormControl sx={{ width: "100%" }} error={touched && Boolean(error)}>
            <TextField
                {...props}
                name={props.question.id}
                fullWidth
                multiline
                minRows={3}
                error={touched && Boolean(error)}
                value={formValue.value}
                inputProps={{ maxLength: maxCharacters }}
                onChange={(event) => {
                    setFieldValue(props.question.id, {
                        value: event.target.value,
                        fileNames: formValue.fileNames,
                    });
                    debounceFunc(event.target.value);
                }}
                placeholder={formatMessage({ defaultMessage: "Write here..." })}
                helperText={
                    <Stack direction="row" justifyContent="space-between">
                        <Typography>{touched && error ? error.value : ""}</Typography>
                        {counterText && <Typography>{counterText}</Typography>}
                    </Stack>
                }
            />
        </FormControl>
    );
};

export default TextQuestion;
